import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, Star } from "lucide-react";

const empty = { name: "", location: "", work: "", comment: "", rating: 5, date: "", published: false };

export default function AdminTestimonials() {
    const [items, setItems] = useState([]);
    const [form, setForm] = useState(null);

    const load = useCallback(() => api.get("/admin/testimonials").then(r => setItems(r.data)), []);
    useEffect(() => { load(); }, [load]);

    const save = async () => {
        try { await api.post("/admin/testimonials", form); toast.success("Guardado"); setForm(null); load(); }
        catch { toast.error("Erro"); }
    };
    const del = async (id) => { if (window.confirm("Eliminar?")) { await api.delete(`/admin/testimonials/${id}`); load(); } };

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h1 className="font-display text-3xl font-bold text-stone-900">Testemunhos</h1>
                <button onClick={() => setForm(empty)} className="btn-ochre px-5 py-2 rounded-full text-sm font-medium flex items-center gap-2">
                    <Plus className="w-4 h-4" /> Novo
                </button>
            </div>
            <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-4 mb-6">Adicione apenas testemunhos reais de clientes.</p>
            <div className="grid md:grid-cols-2 gap-4">
                {items.map(t => (
                    <div key={t.id} className="bg-white rounded-xl border border-stone-200 p-5">
                        <div className="flex gap-0.5 mb-2">{Array.from({length: t.rating}).map((_, i) => <Star key={`${t.id}-star-${i}`} className="w-4 h-4 fill-amber-500 text-amber-500" />)}</div>
                        <p className="text-stone-700 mb-3">"{t.comment}"</p>
                        <div className="text-sm font-medium">{t.name} — {t.location}</div>
                        <div className="text-xs text-stone-500 mb-3">{t.work} • {t.published ? "Publicado" : "Rascunho"}</div>
                        <button onClick={() => del(t.id)} className="text-xs text-red-600"><Trash2 className="w-3 h-3 inline" /> Eliminar</button>
                    </div>
                ))}
                {items.length === 0 && <p className="text-stone-500">Sem testemunhos.</p>}
            </div>

            {form && (
                <div className="fixed inset-0 bg-stone-950/60 z-50 flex items-center justify-center p-4" onClick={() => setForm(null)}>
                    <div className="bg-white rounded-xl max-w-lg w-full p-6 space-y-3" onClick={(e) => e.stopPropagation()}>
                        <h2 className="font-display font-bold text-xl">Novo testemunho</h2>
                        <input placeholder="Nome" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="w-full border rounded p-2" />
                        <input placeholder="Localidade" value={form.location} onChange={(e) => setForm({...form, location: e.target.value})} className="w-full border rounded p-2" />
                        <input placeholder="Tipo de trabalho" value={form.work} onChange={(e) => setForm({...form, work: e.target.value})} className="w-full border rounded p-2" />
                        <textarea placeholder="Comentário" rows={4} value={form.comment} onChange={(e) => setForm({...form, comment: e.target.value})} className="w-full border rounded p-2" />
                        <input type="number" min={1} max={5} value={form.rating} onChange={(e) => setForm({...form, rating: parseInt(e.target.value) || 5})} className="w-full border rounded p-2" />
                        <label className="flex items-center gap-2"><input type="checkbox" checked={form.published} onChange={(e) => setForm({...form, published: e.target.checked})} /> Publicar</label>
                        <div className="flex gap-2 pt-2">
                            <button onClick={save} className="btn-ochre px-6 py-2 rounded-full flex-1">Guardar</button>
                            <button onClick={() => setForm(null)} className="px-6 py-2 border border-stone-300 rounded-full">Cancelar</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
